export const educationData = [
  {
    id: 1,
    institution: "Maharaja Agrasen Institute Of Technology",
    course: `B.Tech in Electronics and communication`,
    startYear: "2019 ",
    endYear: "2023 (expected)",
    scoreObtained: "CGPA - 8.97 [till 6th sem]"
  },
  {
    id: 2,
    institution: "Victoria Public Senior Secondary School",
    course: `Class XII, Science, CBSE Board`,
    startYear: "2016",
    endYear: "2018",
    scoreObtained: "Percentage - 84.20"
  },
  {
    id: 3,
    institution: "Victoria Public Senior Secondary School",
    course: `Class X, CBSE Board`,
    startYear: "2014",
    endYear: "2016",
    scoreObtained: "CGPA - 9.2"
  },

  //   {
  //     id: 3,
  //     institution: "Kendriya Vidyalaya",
  //     course: "Schooling",
  //     startYear: "2005",
  //     endYear: "2015",
  //   },
];
